<mat-chip-set class="app-select-chip-set" role="presentation">
  @for (item of items; track item.option) {
    <mat-chip class="app-select-chip" [disabled]="disabled || item.disabled" [removable]="!disabled && !item.disabled" disableRipple (removed)="remove(item)">
      <span #label #tooltip="matTooltip" class="app-select-chip__label" [matTooltip]="item.label" matTooltipShowDelay="300" (mouseenter)="syncLabelTooltip(tooltip, label)">{{ item.label }}</span>
      @if (!disabled && !item.disabled) {
        <button matChipRemove type="button" tabindex="-1" [attr.aria-label]="'Remove ' + item.label">
          <mat-icon fontIcon="cancel"></mat-icon>
        </button>
      }
    </mat-chip>
  }
  @if (items.length) {
    <mat-chip
      #moreTooltip="matTooltip"
      class="app-select-chip app-select-chip--more app-select-chip--hidden"
      [disabled]="disabled"
      [removable]="false"
      disableRipple
      matTooltip=""
      matTooltipShowDelay="300"
    >
      <span class="app-select-chip__label"></span>
    </mat-chip>
  }
</mat-chip-set>
